import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconAppsV2: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M4 4H6V6H4V4Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M4 18H6V20H4V18Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M18 4H20V6H18V4Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M18 11H20V13H18V11Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M11 11H13V13H11V11Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M4 11H6V13H4V11Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M11 4H13V6H11V4Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M11 18H13V20H11V18Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
      <path
        d="M18 18H20V20H18V18Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill}
      />
    </Icon>
  );
};

export default IconAppsV2;
